import { Provider } from "react-redux";
import store from "./Redux/store";
import "./App.css";
import Footer from "./component/Footer";
import Header from "./component/Header";
import Main from "./component/Main";
import Nav from "./component/Nav";

function App() {
  return (
    <div>
      <Provider store={store}>
        <Nav />
        <Header />
        <Main />
        <Footer />
      </Provider>
    </div>
  );
}

export default App;
